import Util from '@/utils/util';
const Environment = Util.getEnvironment(); // 获取运行环境

export const getUisHost = () => {
    const map = {
        test: '//test-uis.mp.sohu.com',
        pre: '//uis.mp.sohu.com',
        prod: '//uis.mp.sohu.com',
    }
    return map[Environment]
}

export const getCommentHost = () => {
    const map = {
        test: '//test-uis.mp.sohu.com/comment',
        pre: '//uis.mp.sohu.com/comment',
        prod: '//uis.mp.sohu.com/comment',
    }
    return map[Environment]
}

export const sohuHost = () => {
    const map = {
        test: '//test-www.sohu.com',
        pre: '//pre-www.sohu.com',
        prod: '//v2.sohu.com',
    }
    return map[Environment]
}

export const focusHost = () => {
    const map = {
        test: '//test-www.focus.cn',
        pre: '//pre-www.focus.cn',
        prod: '//article.focus.cn',
    }
    return map[Environment]
}

// 焦点用户中心
export const focusUcenterHost = () => {
    const map = {
        test: '//test-m.focus.cn',
        pre: '//login.focus.cn',
        prod: '//login.focus.cn'
    }
    return map[Environment]
}
